<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'ChiefContractList' }">
          合同列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>查看合同详情</el-breadcrumb-item>
      </el-breadcrumb>
      <!--<div class="rj-breadcrumb__tip">-->
      <!--注：这是页面介绍内容-->
      <!--</div>-->
    </div>
    <base-info-view :contract-num="contractNum" @initInfo="initInfo" />
    <!-- 筛选SBG国内逻辑，SBG国内订单不展示。SBG国内:"部门名称"包含"SBG"或"SMB"或"家庭互联"字段,且"订单分类"不包含"国际" -->
    <!-- 部门编码 000063(SBG)、000036(SMB)、000101（家庭互联） -->
    <orderProcess v-if="isInternational" :contract-num="contractNum" :info="info" />
    <!-- {{ this.$route.query.isSon }}
    {{ typeof(this.$route.query.isSon) }} -->
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="合同明细">
        <productDetail2
          :contract-id="info.id"
          :str-contract-code="contractNum"
          :contract-type="info.contractType"
          :special-product="info.specialProduct"
          :special-cloud-desc="info.specialCloudDesc"
          :multiaddress-value="info.multiaddressValue"
          :multiaddress="info.multiaddress"
          :special-ticket-requirements="info.specialTicketRequirements"
        />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isStrategyList" name="10" label="执行订单明细">
        <contractual-product :str-contract-code="contractNum" :contract-type="info.contractType" :init-info="info" :sales-type="info.salesType" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isStrategyList" name="7" label="约定交付日期">
        <delivery-date :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isStrategyList" name="2" label="发货明细">
        <logistics-info :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isStrategyList" name="6" label="序列号明细">
        <serial-number id="" :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isStrategyList" name="4" label="开票明细">
        <invoice-details :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isStrategyList" name="3" label="销退明细">
        <extinction-details :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isStrategyList" name="5" label="分配明细">
        <pay-for-details :contract-id="info.id" :contract-status="info.contractStatus" />
        <!-- <pay-for-details :contract-id="info.id" :contract-status="info.contractStatus" v-if="info.id" /> -->
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isStrategyList" name="8" label="分批发货明细">
        <part-shipment v-if="info.id" :info-data="info" :contract-id="info.id" :special-cloud-desc-str="info.specialCloudDesc" :str-contract-code="contractNum" :carrier-old="info.carrier" :shipping-type-old="info.shippingType" :contract-type="info.contractType" :source-modify-address="info.sourceModifyAddress" :contract-status="info.contractStatus" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isAssistant && isStrategyList" name="9" label="提前开票">
        <open-ticket-again ref="ticketAgainRef" :info-data="info" />
      </rj-tab-pane>

      <rj-tab-pane v-if="isStrategy && isStrategyList" label="申请发货明细">
        <goodsStrategyDetail ref="ticketAgainRef" :info-data="info" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isSonCpt && isAssistant && isStrategyList" name="11" label="换货明细">
        <change-product-detail :contract-num="contractNum" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import contractualProduct from '../common/contractualProduct';
import baseInfoView from './baseInfo';
import serialNumber from '../common/serialNumber';
import productDetail2 from '../common/productDetail2';
import payForDetails from '../common/payForDetails';
import extinctionDetails from '../common/extinctionDetails';
import InvoiceDetails from '../common/InvoiceDetails';
import deliveryDate from '../common/deliveryDate';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import logisticsInfo from '../common/logisticsInfo';
import partShipment from '../common/partShipment';
import openTicketAgain from '../common/openTicketAgain';
import goodsStrategyDetail from '../goods-strategy-detail/index.vue';
import orderProcess from './order-process/index.vue';
import changeProductDetail from '../common/changeProductDetail.vue';
export default {
  // 合同详情完成后通过 provide 注入给子组件（如 partShipment 多地址判断）
  provide () {
    return {
      // 通过函数下发，子组件每次调用时都拿到最新 info
      contractSingleInfo: () => this.info
    };
  },
  data () {
    return {
      tabsActive: '1',
      info: {
        // 初始化所在部门编码 为空字符串，防止v-if 模版编译报错，
        departmentCode: ''
      }
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    contractualProduct,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    logisticsInfo,
    partShipment,
    serialNumber,
    baseInfoView,
    extinctionDetails,
    InvoiceDetails,
    payForDetails,
    deliveryDate,
    productDetail2,
    openTicketAgain,
    goodsStrategyDetail,
    orderProcess,
    changeProductDetail
  },
  computed: {
    ...mapState({
      user: state => state.user //  业务实体列表-来款记录查询(财务)
    }),
    isSonCpt (val) {
      if (typeof (this.$route.query.isSon) === 'string') {
        if (this.$route.query.isSon === 'true') {
          return true;
        } else {
          return false;
        }
      } else {
        return this.$route.query.isSon;
      }
    },

    // 商务权限
    isAssistant () {
      return this.user.perssimionCodeList.some(i => i === 'assistantContractList');
    },

    // 判断是否是战略合同
    isStrategy () {
      return String(this.$route.query.isSon) === 'true';
    },

    // 显示逻辑：战略合同的权限
    isStrategyList () {
      if (this.isStrategy) {
        return this.$store.state.user?.perssimionCodeList.some(i => i === 'strategicPartialShipmentContractsList');
      } else {
        return true;
      }
    },
    // 是否国际
    isInternational () {
      return !(['国际业务下单', '国际分销下单'].includes(this.info.contractType) || (this.info.contractType === '服务订单' && this.info.civilInternational)) && !['000063', '000036', '000101'].includes(this.info.departmentCode.slice(0, 6));
    }
  },
  methods: {
    initInfo (info) {
      this.info = info;
    },
    nameLocation () {
      let transact = this.$route.query.transact;
      if (transact) {
        this.tabsActive = '8';
      }
      if (transact === '9') {
        this.tabsActive = '9';
      }
    }
  },
  // mounted () {

  // },
  created () {
    this.nameLocation();
  }
};
</script>
